export const ERROR_CODES = {
  ACTIVE_PAYMENT_LINK_AVAILABLE: 'active_payment_link_available' // POLICY_CASES.PAYMENT_LINK 1001
}
